import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput", "results", "selectedList", "hiddenInputs"]
  static values = {
    users: Array
  }

  connect() {
    this.selectedUsers = new Map()
  }

  search(event) {
    const query = event.target.value.trim().toLowerCase()

    if (query.length === 0) {
      this.clearResults()
      return
    }

    const matches = this.usersValue.filter(user => {
      const name = user.name.toLowerCase()
      const email = user.email.toLowerCase()
      const organisation = (user.organisation || '').toLowerCase()
      return (name.includes(query) || email.includes(query) || organisation.includes(query)) &&
             !this.selectedUsers.has(user.id)
    })

    this.renderResults(matches)
  }

  clearResults() {
    setTimeout(() => {
      this.resultsTarget.innerHTML = ''
      this.resultsTarget.classList.remove('show')
    }, 200)
  }

  renderResults(users) {
    if (users.length === 0) {
      this.resultsTarget.innerHTML = '<div class="dropdown-item text-muted">No users found</div>'
      this.resultsTarget.classList.add('show')
      return
    }

    this.resultsTarget.innerHTML = users.map(user => {
      const displayName = user.organisation ? `${user.name} (${user.organisation})` : user.name
      return `
        <button type="button"
                class="dropdown-item text-dark"
                data-action="click->training-user-selector#selectUser"
                data-user-id="${user.id}"
                data-user-name="${user.name}"
                data-user-organisation="${user.organisation || ''}">
          ${displayName}
        </button>
      `
    }).join('')

    this.resultsTarget.classList.add('show')
  }

  selectUser(event) {
    const userId = parseInt(event.currentTarget.dataset.userId)
    const userName = event.currentTarget.dataset.userName
    const userOrganisation = event.currentTarget.dataset.userOrganisation

    const displayName = userOrganisation ? `${userName} (${userOrganisation})` : userName

    this.selectedUsers.set(userId, { name: userName, organisation: userOrganisation })

    this.renderSelectedUsers()

    this.searchInputTarget.value = ''
    this.resultsTarget.innerHTML = ''
    this.resultsTarget.classList.remove('show')
  }

  removeUser(event) {
    const userId = parseInt(event.currentTarget.dataset.userId)
    this.selectedUsers.delete(userId)
    this.renderSelectedUsers()
  }

  renderSelectedUsers() {
    // Render selected users list (matching existing user selector pattern)
    this.selectedListTarget.innerHTML = Array.from(this.selectedUsers.entries()).map(([userId, user]) => {
      const displayName = user.organisation ? `${user.name} (${user.organisation})` : user.name
      return `
        <div class="mb-2">
          <span>${displayName}</span>
          <button type="button"
                  class="btn btn-sm btn-outline-danger ms-2"
                  data-action="click->training-user-selector#removeUser"
                  data-user-id="${userId}"
                  title="Remove user">&times;</button>
        </div>
      `
    }).join('')

    // Render hidden inputs for form submission
    this.hiddenInputsTarget.innerHTML = Array.from(this.selectedUsers.keys()).map(userId => {
      return `<input type="hidden" name="user_ids[]" value="${userId}">`
    }).join('')
  }

  disconnect() {
    this.resultsTarget.classList.remove('show')
  }
}
